import { Wallet } from "@terra-money/feather.js";
import { KeplrImage } from "components/icons/KeplrImage";
import { TerraStationSVG } from "components/icons/TerraStationSvg";
import { WalletName, WalletType } from "@goblinhunt/cosmes/wallet";
import { useWallet } from "provider/WalletProvider";
import React, { ReactNode, useEffect } from "react"
import { WALLET_SETTINGS } from "utils/Constants";
import { LuncDash } from "components/icons/LuncDash";
import { GalaxyStation } from "components/icons/galaxyStation";

type WalletInfo = {
    name: string,
    description: string,
    image: ReactNode,
    onConnect: () => void
}


export function WalletModal() {
    const { connect } = useWallet()

    const createWalletInfo = (name: WalletName, type: WalletType, image: ReactNode) => ({
        name: WALLET_SETTINGS[name].name,
        description: type,
        image,
        onConnect: () => connect(name, type)
    })

    let wallets: WalletInfo[] = [
        createWalletInfo(WalletName.STATION, WalletType.EXTENSION, <TerraStationSVG />),
        createWalletInfo(WalletName.GALAXYSTATION, WalletType.EXTENSION, <GalaxyStation />),
        createWalletInfo(WalletName.KEPLR, WalletType.EXTENSION, <KeplrImage />),
        createWalletInfo(WalletName.STATION, WalletType.WALLETCONNECT, <TerraStationSVG />),
        createWalletInfo(WalletName.GALAXYSTATION, WalletType.WALLETCONNECT, <GalaxyStation />),
        createWalletInfo(WalletName.KEPLR, WalletType.WALLETCONNECT, <KeplrImage />),
        createWalletInfo(WalletName.LUNCDASH, WalletType.WALLETCONNECT, <LuncDash />),
    ]


    return <div className="modal fade" id="wallet-modal" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel1">Connect Your Wallet</h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div className="modal-body">

                    <ul className="p-0 m-0">
                        {
                            wallets.map((e, i) => <li key={i} className="d-flex mb-4 pb-1">
                                <div className="avatar flex-shrink-0 me-3">
                                    <span className="avatar-initial rounded">
                                        {e.image}
                                    </span>
                                </div>
                                <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                    <div className="me-2">
                                        <h6 className="mb-0">{e.name}</h6>
                                        <small className="text-muted">{e.description}</small>
                                    </div>
                                    <div className="user-progress">
                                        <button onClick={e.onConnect} data-bs-dismiss="modal" aria-label="Close" className="btn btn-primary">Connect</button>
                                    </div>
                                </div>
                            </li>)
                        }
                    </ul>
                </div>
            </div>
        </div>
    </div>
}